export default __webpack_public_path__ + "static/media/ic_report.922a2259.svg";